module.exports = __webpack_public_path__ + "img/svg/recover-account-background.7deaa7003042bab9ce22b61b768f0edf.svg";